module.exports = __webpack_public_path__ + "img/authorityBtn.c5d07c65.png";